import React from 'react';

import component from './component';
import Link from './Link'
import Nav from './Nav';
import UserTools from './UserTools';

export default component('Header', function({data}) {

  return (
    <div className='Header'>
      <div className='Header-Content'>
        <div className='Header-Logo'>
          <Link name='home' className='Header-Link' title={data.cursor('header').get('title')}></Link>
        </div>
        <div className='Header-Menu'>
          <Nav route={data.cursor('route')}
               data={data.cursor('nav')} />
        </div>
        <div className='Header-Auth'>
          <UserTools user={data.cursor('user')} request={data.cursor('request')} />
        </div>
      </div>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/Header.js